import { Box, Button, Container, Grid } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import SettingsApplicationsTwoToneIcon from "@mui/icons-material/SettingsApplicationsTwoTone";
import GroupTwoToneIcon from "@mui/icons-material/GroupTwoTone";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { deleteTableDots, instance } from "../Components/config";
import { LoaderBox } from "../Components/LoaderBox";

function Roles() {
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  deleteTableDots(0);
  const detailRol = (id, nombre) => {
    navigate("/RolEditar", { state: { id: id, nombre: nombre } });
  };
  const asignRol = (id, nombre) => {
    navigate("/RolAsignar", { state: { id: id, nombre: nombre } });
  };
  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "nombre",
      header: "Nombre",
      enableColumnFilter: false,
    },
    {
      accessorFn: (row) => `${row.rolId} ${row.nombre}`, //accessorFn used to join multiple data into a single cell
      id: "name", //id is still required when using accessorFn instead of accessorKey
      header: "",
      //size: 250,
      enableColumnFilter: false,
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {/* using renderedCellValue instead of cell.getValue() preserves filter match highlighting */}
          <Button
            onClick={() => detailRol(row.original.id, row.original.nombre)}
          >
            <SettingsApplicationsTwoToneIcon />
            Funciones
          </Button>
        </Box>
      ),
    },
    // {
    //   accessorFn: (row) => `${row.rolId} ${row.nombre}`, //accessorFn used to join multiple data into a single cell
    //   id: "name", //id is still required when using accessorFn instead of accessorKey
    //   header: "",
    //   //size: 250,
    //   enableColumnFilter: false,
    //   Cell: ({ renderedCellValue, row }) => (
    //     <Box
    //       sx={{
    //         display: "flex",
    //         alignItems: "center",
    //         gap: "1rem",
    //       }}
    //     >
    //       {/* using renderedCellValue instead of cell.getValue() preserves filter match highlighting */}
    //       <Button
    //         onClick={() => detailRol(row.original.id, row.original.nombre)}
    //       >
    //         <EditTwoToneIcon />
    //         Editar
    //       </Button>
    //     </Box>
    //   ),
    // },
    {
      accessorFn: (row) => `${row.id} ${row.nombre}`, //accessorFn used to join multiple data into a single cell
      id: "name", //id is still required when using accessorFn instead of accessorKey
      header: "",
      disableColumnMenu: true,
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {/* using renderedCellValue instead of cell.getValue() preserves filter match highlighting */}
          <Button onClick={()=>asignRol(row.original.id, row.original.nombre)}>
            <GroupTwoToneIcon />
            Usuarios
          </Button>
        </Box>
      ),
    },
  ]);

  if (isLoading) {
    async function getItems() {
      try {
        const { data } = await instance.get("/rol");
        setItems(data);
      } catch (error) {
        alert(error);
      }
    }
    getItems();
    setLoading(false);
  }
  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxWidth="lg"
        sx={{
          marginTop: 2,
          marginBottom: 2
        }}
        className="TableContainer"
      >
        <MaterialReactTable
          localization={MRT_Localization_ES}
          columns={columns}
          data={items}
          renderTopToolbarCustomActions={({ table }) => (
            <Box sx={{ display: "flex", gap: "1rem", p: "4px" }}>
              <Button
                color="success"
                onClick={() => {
                  navigate("/RolAgregar");
                }}
                variant="contained"
              >
                Agregar Rol
              </Button>
            </Box>
          )}
          //disableColumnMenu={true}
          enableColumnFilters={false}
          enableGlobalFilter={true}
          enableColumnFilterModes={false}
          //enableDensityToggle={false}
          //enableFullScreenToggle={false}
          enableHiding={false}
          globalFilterFn="contains"
          enableSorting={false}
          enableRowActions={false}
          initialState={{ columnVisibility: { id: false } }}
        />
      </Container>
    </LoaderBox>
  );
}

export { Roles };
